import React from "react";
import rehypeReact from 'rehype-react';
import cls from "classnames";
import * as styles from 'src/styles/pages/blog-id.module.scss';
import {Layout} from "src/components/organisms/Layout";
import {VideoContent} from "src/components/organisms/Video/VideoContent";
import {Footer} from "src/components/organisms/Video/Footer";
import {graphql, Link, withAssetPrefix} from "gatsby";
import {BlogImgSharp} from "components/organisms/BlogImgSharp";
import {BlogYtIframe} from "components/organisms/BlogYtIframe";
import {IdHeading} from "components/organisms/IdHeading";
import {AdditionalCard} from "components/organisms/Video/AdditionalCard";
import {AbstractContentLibraryCard} from "components/organisms/ContentLibrary/Card";
import {hhmmssToMinutesString} from "util/hhmmssToString";
import {slugifyLowered} from "util/slugifyLowered";
import {SmartLink} from "components/atoms/SmartLink";


// @ts-ignore
const renderAst = new rehypeReact({
    Fragment: React.Fragment,
    createElement: React.createElement,
    components: {
        'img-sharp-inline': BlogImgSharp,
        'iframe': BlogYtIframe,

    },
}).Compiler

export type PostContext = {
    nodeId: string,
    authorsIds?: string[],
    furtherReading: string[],
    furtherReadingCount: number,
    latestPostsCount: number,
}
type postProps = {
    pageContext: PostContext,
    data: {
        videosJson: Queries.VideosJson,
        allAuthorsJson: { nodes: Queries.AuthorsJson[] }
        allFormsJson: { nodes: Queries.FormsJson[] }
        furtherReading: Queries.VideosJsonConnection
        latestPosts: Queries.VideosJsonConnection
        postJsonId: string
    }
}

function Video({
                   pageContext,
                   data: {videosJson, allAuthorsJson, allFormsJson, furtherReading, latestPosts}
               }: postProps) {
    const posts = [...furtherReading.nodes, ...latestPosts.nodes]
    const author = allAuthorsJson.nodes[0];
    const authorSocials: {
        site: string,
        url: string
    }[] = [
        author?.data?.linkedin?.iv && {
            site: "linkedin",
            url: author?.data?.linkedin?.iv
        },
        author?.data?.bsky?.iv && {
            site: "bsky",
            url: author?.data?.bsky?.iv
        },
        author?.data?.twitter?.iv && {
            site: "twitter",
            url: author?.data?.twitter?.iv
        },
    ].filter(el => Boolean(el) && typeof el === "object" && el !== null);

    const post = videosJson
    return (
        <>
            <div className={"bg-dark"} style={{
                height: "86px"
            }}>

            </div>
            <Layout
                forms={allFormsJson.nodes}
                className={styles.page}
                button={{
                    className: cls('bg-cyan color-dark'),
                }}
            >
                <div className={cls("bs-flex-container l", styles.customFlexContainer)}>
                    <div className={cls(styles.content, styles.container)}>
                        <div className={styles.post}>
                            <VideoContent
                                header={
                                    <>
                                        <h1 className={"h-2"}>{videosJson?.data?.title?.iv || ""}</h1>
                                        <Footer
                                            authors={allAuthorsJson.nodes}
                                            publishedAt={new Date(videosJson.data?.publishedAt?.iv || "")}
                                            duration={hhmmssToMinutesString(videosJson?.data?.duration?.iv || "")}
                                        />
                                    </>
                                }
                                content={post?.childHtmlRehype?.htmlAst ? renderAst(post?.childHtmlRehype?.htmlAst)
                                    : <></>}></VideoContent>
                        </div>
                        <div className={styles.sidebar} id={"blog-sidebar"}>

                            {post.data?.summary?.iv && <AdditionalCard className={"bg-white"}>
                                <IdHeading headingLevel={3}>Summary</IdHeading>
                                <p className={"p-2"}>{post.data.summary.iv}</p>
                            </AdditionalCard>}
                            {allAuthorsJson.nodes[0]?.data?.bio?.iv && <AdditionalCard className={"bg-white"}>
                                <IdHeading headingLevel={3}>
                                    {
                                        author?.data?.name?.iv &&
                                        `About ${author?.data?.name?.iv.split(" ")[0]}` || "Bio"
                                    }
                                </IdHeading>
                                <p className={"p-2"}>{allAuthorsJson.nodes[0]?.data?.bio?.iv}</p>
                            </AdditionalCard>}
                            {authorSocials.length > 0 && <AdditionalCard className={cls("bg-white")}>
                                <IdHeading headingLevel={3}>
                                    Social Media
                                </IdHeading>
                                <div className={styles.iconRow}>
                                    {authorSocials.map(social =>
                                        <a href={social.url}>
                                            <i className={"bs-icon xs icon-" + social.site}></i>
                                        </a>
                                    )}
                                </div>
                            </AdditionalCard>}
                            {post?.data?.tags?.iv && post?.data?.tags?.iv.length > 0
                                && <AdditionalCard className={cls("bg-white")}>
                                    <IdHeading headingLevel={3}>
                                        Tags
                                    </IdHeading>
                                    <div className={styles.tags}>
                                        {
                                            post.data.tags.iv.filter(tag => tag)
                                                .map(tag =>
                                                    <SmartLink to={"/content-library/?tags=" + slugifyLowered(tag)}
                                                          className={cls(
                                                              "button-filled button-bordered bg-white",
                                                              styles.tag
                                                          )}>{tag}</SmartLink>
                                                )
                                        }
                                    </div>
                                </AdditionalCard>
                            }

                            {posts.slice(3, 6).map((post, index) =>
                                (post.data?.relativeUrl?.iv ? <AbstractContentLibraryCard
                                    category={"videos"}
                                    id={"blog-sidebar-item-" + (index + 1)}
                                    description={post.data?.seo?.iv?.description || ""}
                                    headingLevel={6}
                                    coverImageData={post.coverImage?.childImageSharp?.gatsbyImageData}
                                    link={post.data?.relativeUrl?.iv || ""}
                                    publishedAt={post.data?.publishedAt?.iv || ""}
                                    title={post.data?.title?.iv || ""}/> : <></>))
                            }
                        </div>
                    </div>
                </div>
                <div className={"bs-flex-container l"}>
                    <div className={cls(styles.postsContainer)}>
                        <h3 className={styles.postsTitle} id={"further-watching"}>Further watching</h3>
                        <div className={styles.posts} id={"further-watching-wrapper"}>

                            {posts.slice(0, 3).map((post, index) =>
                                (post.data?.relativeUrl?.iv ? <AbstractContentLibraryCard
                                    category={"videos"}
                                    id={"further-watching-item-" + (index + 1)}
                                    description={post.data?.seo?.iv?.description || ""}
                                    headingLevel={6}
                                    coverImageData={post.coverImage?.childImageSharp?.gatsbyImageData}
                                    link={post.data?.relativeUrl?.iv || ""}
                                    publishedAt={post.data?.publishedAt?.iv || ""}
                                    title={post.data?.title?.iv || ""}/> : <></>))
                            }
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export const Head = ({data: {videosJson}}: { pageContext: PostContext, data: { videosJson: Queries.VideosJson } }) => {

    const post = videosJson

    return <>
        <title>{post?.data?.seo?.iv?.title}</title>
        {post?.data?.seo?.iv?.description && <meta name="description" content={post?.data?.seo?.iv?.description}/>}
        {post?.data?.seo?.iv?.title && <meta property="og:title" content={post?.data?.seo?.iv?.title}/>}
        {post?.data?.seo?.iv?.description &&
            <meta property="og:description" content={post?.data?.seo?.iv?.description}/>}
        <meta property="og:type" content="article"/>
        {post.ogCoverImage?.childImageSharp?.resize?.src && <meta property="og:image"
                                                                  content={withAssetPrefix(post.ogCoverImage?.childImageSharp?.resize?.src)}/>}
    </>
}

export const pageQuery = graphql`
query ($nodeId: String!, 
    $authorsIds: [String!]!, 
    $formIds: [String!]!, 
    $postJsonId: String!, 
    $furtherReading: [String!]!, 
    $furtherReadingCount: Int!, 
    $latestPostsCount: Int!) {
  site {
    assetPrefix
  }
  videosJson(id: { eq: $nodeId }) {
    childHtmlRehype {
      htmlAst
    }
    fields {
      forms
      timeToReadWithoutCode
      timeToReadWithShrunkCode
      timeToReadWithCode
    }
    data {
      title {
        iv
      }
      summary {
        iv
      }
      duration {
        iv
      }
      category {
        iv
      }
      updatedAt {
        iv
      }
      publishedAt {
        iv
      }
      slug {
        iv
      }
      tags {
        iv
      }
      relativeUrl {
        iv
      }
      seo {
        iv {
          title
          description
        }
      }
      furtherReading {
        iv
      }
    }
    created
    status
    coverImage {
      childImageSharp {
        gatsbyImageData(
          pngOptions: { quality: 90 }
          webpOptions: { quality: 90 }
        )
        resize(
          width: 1200
          pngCompressionLevel: 9
          pngQuality: 90
          cropFocus: SOUTHWEST
        ) {
          src
          width
          height
          aspectRatio
          originalName
        }
      }
    }
    ogCoverImage {
      childImageSharp {
        gatsbyImageData(
          pngOptions: { quality: 90 }
          webpOptions: { quality: 90 }
        )
        resize(
          width: 1200
          pngCompressionLevel: 9
          pngQuality: 90
          cropFocus: SOUTHWEST
        ) {
          src
          width
          height
          aspectRatio
          originalName
        }
      }
    }
  }
  allAuthorsJson(filter: { jsonId: { in: $authorsIds } }) {
    nodes {
      data {
        description {
          iv
        }
        bio {
          iv
        }
        email {
          iv
        }
        linkedin {
          iv
        }
        bsky {
          iv
        }
        twitter {
          iv
        }
        name {
          iv
        }
        thirdPartyAuthor {
          iv
        }
      }
      authorImage {
        childImageSharp {
          gatsbyImageData(
            webpOptions: { quality: 90 }
            pngOptions: { quality: 90 }
            width: 300
            height: 300
            transformOptions: { cropFocus: NORTH }
          )
        }
      }
    }
  }
  
  
  
  furtherReading: allVideosJson(
    limit: $furtherReadingCount
    filter: {jsonId: {in: $furtherReading}}
  ) {
    nodes {
        id
        jsonId
        status
        data {
          title {
            iv
          }
          relativeUrl {
            iv
          }
          seo {
            iv {
              title
              description
            }
          }
          authors {
            iv {
              id
              data {
                name {
                  iv
                }
                description {
                  iv
                }
              }
            }
          }
          category {
            iv
          }
          tags {
            iv
          }
          publishedAt {
            iv
          }
          updatedAt {
            iv
          }
          furtherReading {
            iv
          }
        }
        coverImage {
          childImageSharp {
            gatsbyImageData(pngOptions: {quality: 90}, webpOptions: {quality: 90})
            resize(
              width: 1200
              pngCompressionLevel: 9
              pngQuality: 90
              cropFocus: SOUTHWEST
            ) {
              src
              width
              height
              aspectRatio
              originalName
            }
          }
        }
    }
  }
  latestPosts: allVideosJson(
  limit: $latestPostsCount,
  filter: {jsonId: {ne: $postJsonId}},
  sort: {fields: data___publishedAt___iv, 
                        order: DESC}
  ) {
    nodes {
        id
        jsonId
        status
        data {
          title {
            iv
          }
          relativeUrl {
            iv
          }
          seo {
            iv {
              title
              description
            }
          }
          authors {
            iv {
              id
              data {
                name {
                  iv
                }
                description {
                  iv
                }
              }
            }
          }
          category {
            iv
          }
          tags {
            iv
          }
          publishedAt {
            iv
          }
          updatedAt {
            iv
          }
          furtherReading {
            iv
          }
        }
        coverImage {
          childImageSharp {
            gatsbyImageData(pngOptions: {quality: 90}, webpOptions: {quality: 90})
            resize(
              width: 1200
              pngCompressionLevel: 9
              pngQuality: 90
              cropFocus: SOUTHWEST
            ) {
              src
              width
              height
              aspectRatio
              originalName
            }
          }
        }
    }
  }
  allFormsJson(filter: {fields: {hashedIdSelector: {in: $formIds}}}) {
    nodes {
      fields {
        hashedIdSelector
        idSelector
      }
      title
      successTitle
      successDetails
      successDescription
      items {
        type
        required
        placeholder
        name
        hidden
        gridColumn
      }
      formId
      id
      details
      controls {
        terms {
          name
        }
        button {
          caption
        }
      }
      eventAction
    }
  }
}
`;

export default Video
